import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import BulkUpload from '../../../../Commons/BulkUpload';

import { Bold } from '../../../../Styles';
import { Instructions, RulesHeading, Rules, RuleList } from './styles';

import { setUploadInventoryFileAction, setUploadInventoryFileBatch, downloadTemplateFile, uploadFilledTemplateFile } from '../../../../../actions/inventoryActionsV2';

import { SPJ_ACTIONS } from '../../../../../commons/utils';

const AddBulkLabItems = ({ open, performingItemUpdate, onSubmit, onClose, ...props }) => {
	const downloadTemplate = async (action, onError) => {
		const { downloadTemplateFile } = props;

		await downloadTemplateFile(action, onError);
	};

	const uploadFilledTemplate = async (action, formData, onSubmit, onError) => {
		const { uploadFilledTemplateFile } = props;

		await uploadFilledTemplateFile(action, formData, onSubmit, onError);
	};

	let { uploadInventoryFileAction, uploadInventoryFileBatch, uploadInventoryFileType } = props;
	let { setUploadInventoryFileAction, setUploadInventoryFileBatch } = props;

	return (
		<BulkUpload
			open={open}
			title={(performingItemUpdate && 'Update Items In Bulk') || 'Add Items In Bulk'}
			spjAction={(performingItemUpdate && SPJ_ACTIONS.LAB_INVENTORY_UPDATE) || SPJ_ACTIONS.LAB_INVENTORY_CREATE}
			uploadFileAction={uploadInventoryFileAction || ''}
			uploadFileBatch={uploadInventoryFileBatch || ''}
			uploadFileType={uploadInventoryFileType || ''}
			onClose={onClose}
			onSuccess={onSubmit}
			downloadTemplateFile={downloadTemplate}
			uploadFilledTemplateFile={uploadFilledTemplate}
			setUploadFileAction={setUploadInventoryFileAction}
			setUploadFileBatch={setUploadInventoryFileBatch}
		>
			<Instructions>Download the sample file and add item details and upload again to add multiple items to inventory at once.</Instructions>

			<RulesHeading>
				<Bold>Rules:</Bold>
			</RulesHeading>

			<Rules>
				<RuleList>
					<li>
						<Bold>Do not alter</Bold> the file headers or the pre-filled values like <Bold>Category</Bold>, <Bold>Sub Category</Bold>, <Bold>Dentira Product Name</Bold>, etc.
					</li>

					{performingItemUpdate && (
						<>
							<li>
								Details for <Bold>locked items</Bold> cannot be updated.
							</li>
						</>
					)}

					<li>
						All fields are <Bold>mandatory</Bold> fields.
					</li>

					<li>
						<Bold>Item ID</Bold> should be unique. It cannot contain underscore(_), slash(/) and colon(:).
					</li>

					<li>
						<Bold>Item Name</Bold> should be at max 150 characters in length.
					</li>

					<li>
						<Bold>Item Description</Bold> should be at max 500 characters in length.
					</li>

					<li>
						<Bold>Price</Bold> should be a zero or positive numeric value, without currency symbol.
					</li>
				</RuleList>
			</Rules>
		</BulkUpload>
	);
};

const mapStateToProps = (state) => {
	return {
		groupId: state?.session?.groupId,
		uploadInventoryFileAction: state?.inventory?.uploadInventoryFileAction || '',
		uploadInventoryFileBatch: state?.inventory?.uploadInventoryFileBatch || '',
		uploadInventoryFileType: state?.inventory?.uploadInventoryFileType || '',
	};
};

const mapDispatch = {
	downloadTemplateFile,
	uploadFilledTemplateFile,
	setUploadInventoryFileAction,
	setUploadInventoryFileBatch,
};

export default withRouter(connect(mapStateToProps, mapDispatch)(AddBulkLabItems));
